import { render, staticRenderFns } from "./FamSlides.vue?vue&type=template&id=326ed11c&scoped=true&lang=pug"
import script from "./FamSlides.vue?vue&type=script&lang=js"
export * from "./FamSlides.vue?vue&type=script&lang=js"
import style0 from "./FamSlides.vue?vue&type=style&index=0&id=326ed11c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326ed11c",
  null
  
)

export default component.exports